import { useQuery } from '@tanstack/react-query';
import type { AxiosInstance } from 'axios';
import { useAppLanguageSelector } from '@gov-nx/core/hooks';
import { useConfiguration } from '@gov-nx/core/service';
import type { CmsMessage, CmsMessageResponse } from './types';

export const useCmsMessagesQuery = (
	axiosCmsInstance: AxiosInstance,
	{
		onError,
		onSuccess,
	}: {
		onError?: (errorMessage: string) => void;
		onSuccess?: (data: CmsMessage[]) => void;
	}
) => {
	const { cmsKeyCache } = useConfiguration();
	const { language } = useAppLanguageSelector();
	return useQuery({
		onError,
		onSuccess,
		queryFn: async () => {
			const response = await axiosCmsInstance.get<CmsMessageResponse>(
				`/messages/${language}.json?v=${cmsKeyCache}`
			);
			return response.data.data;
		},
		retry: 0,
		refetchOnWindowFocus: false,
		queryKey: ['cms-messages', language, cmsKeyCache],
	});
};
